import React, { type FC } from 'react'
import { Outlet } from 'react-router'
import { Header } from '../common/header/Header'
import { UnreadNotice } from '../common/unread-notice/UnreadNotice'

/**
 * Parent component for all dashboard routes.
 * @constructor
 */
export const Dashboard: FC = () => {
  return (
        <div style={{ marginTop: '5em' }}>
            <Header/>
            <UnreadNotice/>
            <Outlet/>
        </div>
  )
}
